module.exports = __webpack_public_path__ + "1ce635ffce0ef1128f8cf332274810f6.png";